//initial redux
import { all, takeEvery, call, put } from "redux-saga/effects";
import masterImportService from "../../../../services/masterImport";

const initialState = {
	isBusy: true,
	tagLabels: null
};

/////////
//types
export const types = {
	GET_DATA: "screens/MasterRules/Import/Status/TagLabels/GET_DATA",
	ON_DATA_RETURNED: "screens/MasterRules/Import/Status/TagLabels/ON_DATA_RETURNED",
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.GET_DATA:
				return { ...state, isBusy: true };
			case types.ON_DATA_RETURNED:
				return { ...state, isBusy: false, tagLabels: action.payload };
			default:
				return state;
		}
	}
};

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([
			this.getData()
		]);
	},

	*getData() {

		yield takeEvery(types.GET_DATA, function*({ payload }) {

			let tagLabels = yield call(
				masterImportService.getTagLabelsLinkedToSpreadsheetImport,
				payload);

			if(!tagLabels.length)
				tagLabels = [];

			yield put(actions.onDataReturned(tagLabels));

		});
	},

};

////////
//actions
export const actions = {

	getData(payload) {
		return {
			type: types.GET_DATA,
			payload: payload,
		}
	},

	onDataReturned(payload) {
		return {
			type: types.ON_DATA_RETURNED,
			payload: payload
		}
	}

};



// WEBPACK FOOTER //
// ./src/ui/ImportOverview/ImportStatus/ImportStatusTags/redux.js